var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.less';

var Searchable = function (_Component) {
  _inherits(Searchable, _Component);

  function Searchable(props) {
    _classCallCheck(this, Searchable);

    var _this = _possibleConstructorReturn(this, (Searchable.__proto__ || Object.getPrototypeOf(Searchable)).call(this, props));

    _this.onSearch = function (e) {
      _this.setState({
        searchText: e.target.value,
        currentFocus: null
      });
    };

    _this.onKeyDown = function (e) {
      var children = _this.props.children;
      var currentFocus = _this.state.currentFocus;

      var items = children.filter(_this.matchesSearch).map(function (child) {
        return child.props.id;
      });
      _this.setState({
        focusActive: false
      });
      if (e.keyCode === 27) {
        // escape
        _this.deleteText(e);
      } else if (e.keyCode === 40) {
        // down arrow
        e.preventDefault();
        var index = items.findIndex(function (i) {
          return i === currentFocus;
        });
        index = items.length > index + 1 ? index + 1 : 0;
        _this.setState({
          currentFocus: items[index],
          focusActive: true
        });
      } else if (e.keyCode === 38) {
        // up arrow
        e.preventDefault();
        if (currentFocus) {
          var _index = items.findIndex(function (i) {
            return i === currentFocus;
          });
          _index = _index - 1 >= 0 ? _index - 1 : items.length - 1;
          _this.setState({
            currentFocus: items[_index],
            focusActive: true
          });
        }
      }
    };

    _this.updateFocus = function (id) {
      _this.setState({
        currentFocus: id,
        focusActive: false
      });
    };

    _this.deleteText = function () {
      _this.setState({
        searchText: ''
      });
    };

    _this.matchesSearch = function (e) {
      var searchText = _this.state.searchText;

      if (searchText === '' || e.props.children.props.text.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    };

    _this.state = {
      searchText: '',
      currentFocus: null,
      focusActive: false
    };
    return _this;
  }

  _createClass(Searchable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children;
      var _state = this.state,
          currentFocus = _state.currentFocus,
          focusActive = _state.focusActive,
          searchText = _state.searchText;

      return React.createElement(
        'div',
        { className: styles.searchableContainer + ' ' + className },
        React.createElement(
          'div',
          { className: styles.searchField },
          React.createElement('input', { className: styles.input, value: searchText, onChange: this.onSearch }),
          searchText.length ? React.createElement('div', { role: 'button', className: styles.closeIcon + ' icon-close-large', onClick: this.deleteText }) : null
        ),
        React.createElement(
          'div',
          { className: styles.children },
          React.Children.map(children.filter(this.matchesSearch), function (child) {
            return React.cloneElement(child, {
              focusId: focusActive ? currentFocus : null,
              updateFocus: _this2.updateFocus
            });
          })
        )
      );
    }
  }]);

  return Searchable;
}(Component);

export default Searchable;


Searchable.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};

Searchable.defaultProps = {
  children: {},
  className: ''
};